export const APPOINTMENTS = "/api/appointments/cps"
export const APPOINTMENT = "/api/appointments/:param"

export const DOWNLOAD_SCHEDULE = "/api/users/schedules"
